import type { FC, ReactNode } from 'react';
import classnames from 'classnames';
import type { NavLinkProps } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

import style from './style.scss';

interface Props extends NavLinkProps {
  label: string;
  icon?: ReactNode;
  collapsed: boolean;
  content?: ReactNode;
}

const NavBarLink: FC<Props> = ({ label, icon, collapsed, content = null, ...props }) => {
  const linkClassName = classnames(style.link, {
    [style.link_collapsed]: collapsed
  });

  return (
    <NavLink
      {...props}
      className={({ isActive }) => classnames(linkClassName, { [style.link_active]: isActive })}
    >
      <div className={style.iconContainer}>
        {icon}
        {collapsed && content}
      </div>
      {label}
      {!collapsed && content}
    </NavLink>
  );
};

NavBarLink.displayName = 'NavBarLink';

export default NavBarLink;
